import { createNavigationContainerRef } from "@react-navigation/native";

export const navigationRef = createNavigationContainerRef();

export const navigate: typeof navigationRef.navigate = (...args) => {
  if (navigationRef.isReady()) {
    navigationRef.navigate(args);
  }
};
